$(function () {
  const isPC = window.matchMedia("(min-width: 1024px)").matches;

  if (isPC) {
    const $slider1 = $(".sec-instagram__list-1");
    const $slider2 = $(".sec-instagram__list-2");
    const $slider3 = $(".sec-instagram__list-3");

    $slider1.append($slider2.children());
    $slider1.append($slider3.children());
    $slider2.remove();
    $slider3.remove();
  }

  const $sliders = $(
    ".sec-instagram__list-1, .sec-instagram__list-2, .sec-instagram__list-3"
  );

  $sliders.each(function (index, slider) {
    // スマートフォン表示でスライダーの自動再生を遅らせる
    if (!isPC) {
      $(slider).on("init", function () {
        const $self = $(this);
        const delay = index === 1 ? 3000 : index * 300;
        setTimeout(function () {
          $self.slick("slickSetOption", "autoplay", true, true);
        }, delay);
      });
    }

    $(slider).slick({
      variableWidth: false,
      autoplay: isPC,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      slidesToShow: isPC ? 3.2 : 2.8,
      swipe: false,
      arrows: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      infinite: true,
    });
  });
});
